// Creates a data format needed by the React component displaying the selectable countries
const createCountryData = (shortNames) => (country) => ({
  value: country,
  text: shortNames[country] ? shortNames[country] : country,
});

// ------ Data ------

// get the country data from a global variable which has been initialised in the template
const allCountries = global.Chuffed && global.Chuffed.supportedCountries || [];

// Short Names will be used to display on the UI
const shortNames = {
  "United Kingdom": "UK",
  "United States": "US",
};

const countriesShownAsButtons = [
  "Australia",
  "United Kingdom",
  "United States",
];

const buttons = countriesShownAsButtons.map(createCountryData(shortNames));

const options = allCountries
  .filter((country) => !~countriesShownAsButtons.indexOf(country))
  .map(createCountryData(shortNames));

export const countriesData = { buttons, options };

// get the category data from a global variable which has been initialised in the template
export const categoriesData = global.Chuffed && global.Chuffed.supportedCategories || [];
